import { render, staticRenderFns } from "./RewardForm.vue?vue&type=template&id=2d84f25a&scoped=true"
import script from "./RewardForm.vue?vue&type=script&lang=js"
export * from "./RewardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84f25a",
  null
  
)

export default component.exports